const BUNDLE_DATA_SOURCE = {
    Manual: 'manual',
    Automated: 'automated',
    Off: 'off'
};

/**
 * FER-896: while AB test #3807ABCDEF is running, every product that reports a bundling data source
 * renders the Automated experience titled "Frequently Bought Together", so the test measures the
 * feature instead of merchandising variance. On that hardcoded path PXM's "Product Bundling - Title"
 * is dropped in favor of the localized default heading. Every other value — including an explicit
 * "Off" and a missing one, which keep the widget hidden — passes through normalized with its title
 * intact.
 *
 * Reverting the hardcode after the test means returning the normalized values untouched.
 *
 * @param {Object} params
 * @param {string} [params.productBundleDataSource] raw "Product Bundling - Data Source" value from PXM
 * @param {string} [params.useItWithTitle] raw "Product Bundling - Title" value from PXM
 * @returns {{ dataSource: string|undefined, title: string|undefined }} title is undefined when the
 *          caller should fall back to the localized default heading
 */
const resolveBundleExperience = ({ productBundleDataSource, useItWithTitle } = {}) => {
    const dataSource = productBundleDataSource?.toLowerCase();
    const isHardcoded = dataSource === BUNDLE_DATA_SOURCE.Manual || dataSource === BUNDLE_DATA_SOURCE.Automated;

    return isHardcoded ? { dataSource: BUNDLE_DATA_SOURCE.Automated, title: undefined } : { dataSource, title: useItWithTitle };
};

export {
    BUNDLE_DATA_SOURCE, resolveBundleExperience
};
